export const DisplayTypesInCancelledReservationsConstant = {
    LIST: 1,
    DETAILS: 2,
}
